export function getSeatUsageText(numUsed: number, numBought?: number | null): string {
    const seatsLabel = numBought === 1 ? 'seat' : 'seats';

    return `You are using ${numUsed} of ${numBought || '∞'} ${seatsLabel}`;
}
